import React from "react";
import NavigationBar from "../navigation-bar/navigation-bar";
import Footer from "../footer/footer";

const Layout = ({children}: {children: React.ReactNode}) => {

    return (
        <>
            <NavigationBar/>
            <main>
                {children}
            </main>
            {/*<Footer/>*/}
        </>
    )

}

export default Layout;